export default __webpack_public_path__ + "static/media/open-mobile-burger.c26525b9.svg";